export const METACOM_LICENSE_TEXT = `METACOM – Nutzungsbedingungen

Mit der Bestätigung erkläre ich Folgendes:

1. Ich besitze eine gültige METACOM-Lizenz (Persönliche Lizenz oder Pro-Lizenz) und bin zur Nutzung der Symbole berechtigt.

2. Die Symbole werden ausschließlich lokal in meinem Browser gespeichert und nicht an den Server von symbolbuch.de übertragen.

3. Ich nutze die Symbole nur für Zwecke der Unterstützten Kommunikation im Rahmen meiner beruflichen Tätigkeit oder persönlichen Nutzung.

4. Gedruckte Materialien (PDF-Export) gebe ich ausschließlich an Personen weiter, die ich klinisch, therapeutisch oder pädagogisch betreue (gemäß METACOM A.4.6b).

Die vollständigen Nutzungsbedingungen sind einsehbar unter:
https://metacom.shop/nutzungsbedingungen/`;

export const GENERAL_COPYRIGHT_TEXT = `Urheberrecht und Datenschutz – Allgemeiner Hinweis

Mit der Bestätigung erkläre ich, dass ich die folgenden Grundsätze zur Kenntnis genommen habe und einhalten werde:

1. Urheberrecht: Sämtliche hochgeladenen Bilder und Materialien unterliegen dem Schutz des Urheberrechts. Ich versichere, dass ich über die erforderlichen Nutzungsrechte an den von mir hochgeladenen Inhalten verfüge oder diese unter einer entsprechenden Lizenz stehen, die die beabsichtigte Nutzung gestattet.

2. Persönlichkeitsrechte: Ich stelle sicher, dass hochgeladene Bilder keine Persönlichkeitsrechte Dritter verletzen. Insbesondere werden keine Fotos von Personen ohne deren ausdrückliche Einwilligung hochgeladen.

3. Datenschutz: Ich verpflichte mich, die geltenden datenschutzrechtlichen Bestimmungen (insbesondere die DSGVO) einzuhalten. Personenbezogene Daten werden nicht ohne Rechtsgrundlage verarbeitet oder über die Plattform weitergegeben.

4. Verantwortlichkeit: Für die Rechtmäßigkeit der hochgeladenen Inhalte bin ich selbst verantwortlich. symbolbuch.de übernimmt keine Haftung für Rechtsverstöße durch nutzerseitig bereitgestellte Materialien.`;
